import { Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImagePickerDialogComponent } from '../forms/form-field/image-picker-dialog/image-picker-dialog.component';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent {

  /**
   * url originale
   */
  @Input() url;

  /**
   * url generata in base64 dopo crop di immagine scelta da file system.
   * se presente, viene visualizzata al posto della url originale
   */
  temporaryUrl;

  @Output() output: EventEmitter<any> = new EventEmitter<any>();

  constructor(protected _injector: Injector) { }

  // Viene chiamato dopo aver croppato l'immagine dalla dialog
  onFileSelected(event){
    const file: File = event.target.files[0]
    const _fileName = file.name;
    const reader = new FileReader();
    reader.addEventListener('load', (event: any)=>{
      const base64 = event.target.result
      let dialogRef = this._injector.get(MatDialog).open(
                                                      ImagePickerDialogComponent, 
                                                      {disableClose: false,
                                                       data: { imgUrl: base64 }
                                                      });
      dialogRef.afterClosed().subscribe(result => {
                                            this.temporaryUrl = result.out;
                                            this.output.emit(this.temporaryUrl);
                                          });
    })
    reader.readAsDataURL(file)
  }
  onFormFieldFocus(){}
  onFormFieldBlur(){}
  onFormFieldInputChange(event){}
}
